// phdat
// sửa tất cả đề xuất thành quy trình
// 27-12-2021

export default {
  Error: {
    "404": "OPP! Không tìm thấy trang.",
    "404_sub": "Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại",
    "500": "Internal Server Error!",
    "500_sub": "Có một số lỗi xảy ra, vui lòng liên hệ với MISA để được trợ giúp",
    "403": "Không có quyền truy cập",
    "403_sub": "Bạn vui lòng liên hệ với admin để được cấp quyền truy cập ứng dụng",
  },
  Button:{
    "BackAmis": "Quay lại",
    "ByNow":"Mua ngay",
    "ActiveNow":"Gia hạn ngay",
    "DeleteUser": 'Xóa người dùng'
  },

  RequestSendExecution:
    "<b>{#SenderName#}</b> đã đề nghị bạn xem xét quy trình <b>{#RequestExecutionName#}</b>",

  // Đồng ý quy trình
  RequestApprovedAuthor:
    "<b>{#SenderName#}</b> đã đồng ý và chuyển tiếp quy trình <b>{#RequestExecutionName#}</b> của bạn",
  RequestApprovedRelatedUser:
    "<b>{#SenderName#}</b> đã đồng ý và chuyển tiếp quy trình <b>{#RequestExecutionName#}</b>",
  RequestApprovedApprover:
    "<b>{#SenderName#}</b> đã đề nghị bạn xem xét quy trình <b>{#RequestExecutionName#}</b>",

  // Đồng ý và kết thúc
  RequestFinishAuthor:
    "<b>{#SenderName#}</b> đã đồng ý và hoàn tất quy trình <b>{#RequestExecutionName#}</b> của bạn",
  RequestFinishRelatedUser:
    "<b>{#SenderName#}</b> đã đồng ý và hoàn tất quy trình <b>{#RequestExecutionName#}</b>",

  // Từ chối quy trình
  RequestRejectAndBackAuthor:
    "<b>{#SenderName#}</b> đã từ chối và trả quy trình <b>{#RequestExecutionName#}</b> về cho bạn",
  RejectAndBackRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và trả quy trình <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",
  RequestRejectedAuthor:
    "<b>{#SenderName#}</b> đã từ chối và trả quy trình <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",
  RequestRejectedRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và trả quy trình <b>{#RequestExecutionName#}</b> về cho <b>{#ApproverName#}</b>",

  RequestRejectedApprover:
    "<b>{#SenderName#}</b> đã từ chối và trả quy trình <b>{#RequestExecutionName#}</b> về cho bạn",

  RequestRejectAndFinishAuthor:
    "<b>{#SenderName#}</b> đã từ chối và kết thúc quy trình <b>{#RequestExecutionName#}</b> của bạn",

  RequestRejectAndFinishRelatedUser:
    "<b>{#SenderName#}</b> đã từ chối và kết thúc quy trình <b>{#RequestExecutionName#}</b>",
  // Hủy bỏ
  RequestCancel:
    "<b>{#SenderName#}</b> đã hủy quy trình <b>{#RequestExecutionName#}</b>",

  // Chỉnh sửa quy trình
  RequestChangeAuthor:
    "<b>{#SenderName#}</b> đã sửa thông tin <b>{#InputName#}</b> trong quy trình <b>{#RequestExecutionName#}</b> của bạn",
  RequestChangeRelatedUser:
    "<b>{#SenderName#}</b> đã sửa thông tin <b>{#InputName#}</b> trong quy trình <b>{#RequestExecutionName#}</b>",

  // Comment
  RequestCommentAuthor:
    "<b>{#SenderName#}</b> đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b> của bạn",
  RequestCommentAuthorGroup: {
    SINGLE:
      "<b>{#SenderName#}</b> đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b> của bạn",
    MULTI:
      "<b>{#SenderName#}</b> và <b>{#OtherUserCount#}</b> người khác đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b> của bạn"
  },
  RequestCommentRelatedUser:
    "<b>{#SenderName#}</b> đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b>",
  RequestCommentRelatedUserGroup: {
    SINGLE:
      "<b>{#SenderName#}</b> đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b>",
    MULTI:
      "<b>{#SenderName#}</b> và <b>{#OtherUserCount#}</b> người khác đã thêm bình luận trong quy trình <b>{#RequestExecutionName#}</b>"
  },
  RequestTagComment:
    "<b>{#SenderName#}</b> đã nhắc đến bạn trong một bình luận thuộc quy trình <b>{#RequestExecutionName#}</b>",
  // người liên quan
  RequestRelatedUserAdd:
    "<b>{#SenderName#}</b> đã thêm bạn là <b>{#InputName#}</b> trong quy trình <b>{#RequestExecutionName#}</b>",
  RequestRelatedUserRemove:
    "<b>{#SenderName#}</b> đã xóa bạn khỏi danh sách <b>{#InputName#}</b> trong quy trình <b>{#RequestExecutionName#}</b>",
  /// Loại quy trình
  RequestAddRequestGroup:
    "<b>{#SenderName#}</b> đã thêm nhóm quy trình <b>{#RequestGroupName#}</b>",
  RequestRemoveRequestGroup:
    "<b>{#SenderName#}</b> đã xóa nhóm quy trình <b>{#RequestGroupName#}</b>",
  RequestAddRequestCategory:
    "<b>{#SenderName#}</b> đã thêm loại quy trình <b>{#RequestCategoryName#}</b>",
  RequestRemoveRequestCategory:
    "<b>{#SenderName#}</b> đã xóa loại quy trình <b>{#RequestCategoryName#}</b>",

  /// Phân công lại
  RequestReassignmentApproved:
    "<b>{#SenderName#}</b> đã phân công lại cho bạn thực hiện 1 quy trình",
  RequestReassignmentWaiting:
    "<b>{#SenderName#}</b> đã hủy đề nghị xem xét quy trình <b>{#RequestExecutionName#}</b>",

  /// Nhắc lịch duyệt
  RequestRemindWaiting: "Bạn có 1 quy trình cần thực hiện sắp hết hạn"
};
